import React from "react";
import styles from "./tableHeader.module.css";

const TableHeader = ({ title, icon, kcal, time }) => {
  return (
    <th>
      <div className={styles.headwrap}>
        <div className={styles.headtitle}>{title}</div>
        <div className={styles.headimg}>{icon && <img src={icon} alt={`${title} icon`} className={styles.headicon} />}</div>
      </div>
      <div className={styles.headcon}>
        <div className={styles.headdesc1}>{kcal}</div>
        <div className={styles.headdesc2}>{time}</div>
      </div>
    </th>
  );
};

export default TableHeader;
